<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/merchantevaluation/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="true"
      @openAddDialog="openDialog"
      addShowPower="/merchantevaluation/add"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- <el-form-item label="代理商姓名">
        <el-input v-model="formModel.userName" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.agentPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户手机号">
        <el-input v-model="formModel.merPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- <el-form-item label="变动时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item> -->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="代理商ID"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="agentName"
        label="代理商姓名"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        label="代理商手机号"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户号"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        label="商户手机号"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="评价"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="integralNumber"
        label="积分"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="modifierId"
        label="操作人"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="添加"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label-width="138px" label="商户号" prop="merNo">
        <el-input
          type="text"
          v-model="dialogModel.merNo"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="商户名称" prop="merName">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.merName"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="商户手机号" prop="merPhone">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.merPhone"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="是否已评" prop="isEvaluate">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.isEvaluate"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="评价" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="积分" prop="integralNumber">
        <el-select v-model="dialogModel.integralNumber">
          <el-option
            v-for="item in integralNumber"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";
import OrganService from "service/OrganService";
import FinanceService from "service/FinanceService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchantevaluation",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        userId: "",
        agentPhone: "",
        merName: "",
        merPhone: "",
        // time: "",
      },
      dialogModel: {
        merNo: "",
        merName: "",
        merPhone: "",
        isEvaluate: "",
        integralNumber: "",
        remark: "",
      },
      dialogRules: {
        merNo: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else {
                this.getMerNo(value, (res) => {
                  if (res.contents != null) {
                    const id = res.contents;
                    if (!id.id) {
                      callback(new Error("查询不到此商户"));
                      this.dialogModel.merName = "";
                      this.dialogModel.merPhone = "";
                      this.dialogModel.isEvaluate = "";
                    } else {
                      this.dialogModel.merName = id.merName;
                      this.dialogModel.merPhone = id.merPhone;
                      this.dialogModel.isEvaluate =
                        id.isEvaluate == "0" ? "否" : "是";
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此商户"));
                    this.dialogModel.merName = "";
                    this.dialogModel.merPhone = "";
                    this.dialogModel.isEvaluate = "";
                  }
                });
              }
            },
            trigger: ["change"],
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integralNumber: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      tableData: [],
      integralNumber: [],
      submitService: OrganService.merchantevaluationList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getTypeNames("评价得分", (res) => {
      this.integralNumber = res;
    });
    this.load();
  },
  watch: {
    "dialogModel.merNo"(val, oldVal) {
      if (!val) {
        this.dialogModel.merName = "";
        this.dialogModel.merPhone = "";
        this.dialogModel.isEvaluate = "";
      }
    },
    "dialogModel.isEvaluate"(val, oldVal) {
      if (val == "是") {
        this.$message({
          message: "此商户号已进行首次评价，如需继续评价请再次保存即可。",
          type: "warning",
        });
      } else {
        return;
      }
    },
  },
  computed: {
    submitData() {
      //   if (this.formModel.time == null || this.formModel.time == "") {
      //     this.formModel.time = [];
      //   }
      const params = {
        userId: this.formModel.userId,
        agentPhone: this.formModel.agentPhone,
        merName: this.formModel.merName,
        merPhone: this.formModel.merPhone,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      //   if (this.formModel.time.length) {
      //     params.startDate = this.formModel.time[0];
      //     params.endDate = this.formModel.time[1];
      //   }
      return params;
    },
    dialogData() {
      const params = {
        merNo: this.dialogModel.merNo,
        integralNumber: this.dialogModel.integralNumber,
        remark: this.dialogModel.remark,
      };
      return params;
    },
    dialogService() {
      return OrganService.merchantevaluationAdd;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {};
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    openDialog(item) {
      this.dialogClose();
      this.$refs.formDialog.open();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getMerNo(val, onSuccess) {
      const params = {
        merNo: val,
      };
      this.doLoad(
        FinanceService.getMerNo,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        merNo: "",
        merName: "",
        merPhone: "",
        isEvaluate: "",
        integralNumber: "",
        remark: "",
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/MerchantEvaluation.vue